import React from 'react';
import { Subscription } from 'react-apollo';

const SkippableSubscription = ({ skip, ...subscriptionProps }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  skip ? <>{subscriptionProps.children({})}</> : <Subscription {...subscriptionProps} />
);

export default SkippableSubscription;
